import angular from "angular"

// Depends on uib-modal.
import { NavSidebarComponent } from "./nav-sidebar.component"

import { AccountOptionsComponent } from "./account-options/account-options.component"

export const NavModule = angular
    .module("apex.common.nav", [])
    .component("apexNavSidebar", NavSidebarComponent)
    .component("apexSidebarAccountOptions", AccountOptionsComponent)
    .name
